// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wcs0","largestCol":"styles_largestCol__2V0RU","smallestCol":"styles_smallestCol__3s6GU"};